export const columns = [
  {
    field: "ItemCode",
    header: "Item Name",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "ItemCode")} className="">
          <p className="">{row?.product?.name || ""}</p>
        </div>
      </>
    ),
  },


  {
    field: "StockOnQuantity",
    header: "Stock On Quantity",
    accessor: (row, handleCellClick) => (
      <>
        <div
          onClick={() => handleCellClick(row, "StockOnQuantity")}
          className=""
        >
          <p className="w-[6rem]">{row?.balanceQuantity || ""}</p>
        </div>
      </>
    ),
  },
  {
    field: "Unit",
    header: "Unit",
    accessor: (row, handleCellClick) => (
      <>
        <div onClick={() => handleCellClick(row, "Unit")} className="">
          <p className="w-[6rem]">{row?.unit?.unit || ""}</p>
        </div>
      </>
    ),
  },
  {
    field: "itemCodeDetails",
    header: "Item details",
    accessor: (row, handleCellClick) => (
      <div
        onClick={() => handleCellClick(row, "itemDetails")}
        className="cursor-pointer hover:bg-gray100 p-2 rounded transition"
      >
        <p className="truncate w-28 text-sm font-medium text-green700">View</p>
      </div>
    ),
  },


];

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};
